module.exports = __webpack_public_path__ + "static/media/Tesla.3b2c6cc3.webp";